import { on } from '@ember/modifier';
import { action } from '@ember/object';
import { later } from '@ember/runloop';
import { service } from '@ember/service';
import { tracked } from '@glimmer/tracking';

import type { PopupData, Service } from 'webapp-types';
import { TrackingEvent } from 'webapp/enums/tracking';
import { reload } from 'webapp/utils/common';

import PopupInnerContextComponent from 'webapp/components/popup/inner/context';
import SubmitButtonComponent from 'webapp/components/submit-button';

export default class CommonPopupsReloadContextComponent extends PopupInnerContextComponent<PopupData.Common.ReloadContext> {
	@service('analytics') declare analyticsService: Service.Analytics;

	@tracked reloadInProgress = false;

	get changesText() {
		return this.popupData.changesText;
	}

	@action
	reload() {
		if (this.reloadInProgress) {
			return;
		}
		this.reloadInProgress = true;
		this.analyticsService.event(TrackingEvent.RELOADED_AFTER_UPDATE);
		later(reload, 100); // so the event can get triggered reliably
	}
	<template>
		<h3>New application update is ready.</h3>
		<p>Changes will take place after you reload your browser window.</p>
		{{#if this.changesText}}
			<br />
			{{{this.changesText}}}
		{{/if}}

		<div class="controls2">
			<div class="controls2__right">
				<a role="button" class="link link--white" {{on "click" this.close}}>Dismiss</a>
				<SubmitButtonComponent
					@text="Reload"
					@onTrigger={{this.reload}}
					@theme="white-outlined-blue"
					@submitInProgress={{this.reloadInProgress}}
				/>
			</div>
		</div>
	</template>
}
